import type { Libraries } from "@react-google-maps/api";

import { AddressFieldTypes } from "./address.types";

export const GOOGLE_API_LIBRARIES: Libraries = ["places"];

export const autocompleteTypesMap: Map<AddressFieldTypes, string[]> = new Map([
  [AddressFieldTypes.location_address, ["geocode"]],
  [AddressFieldTypes.location_city, ["(cities)"]],
  [AddressFieldTypes.location_state, ["(regions)"]],
]);
